module.exports = __webpack_public_path__ + "static/img/5.56f89bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/5.png
// module id = rpTc
// module chunks = 0